import Work1 from "../../assets/work-1.png";
import Work2 from "../../assets/work-2.png";
import Work3 from "../../assets/work-3.png";
import Work4 from "../../assets/work-4.png";
import Work5 from "../../assets/work-5.png";
import Work6 from "../../assets/work-6.png";
import Work7 from "../../assets/work-7.png";
import Work8 from "../../assets/work-8.png";

const Menu = [
    {
        id: 1,
        image: Work1,
        title: "Weather application in React JS using OpenEeatherMap API",
        url: "https://babi2707.github.io/weather-app/",
        category: "React",
    },
    {
        id: 2,
        image: Work6,
        title: "Tip Calculator App made in Android Studio using Kotlin",
        url: "https://github.com/babi2707/TipTime",
        category: "Android Studio",
    },
    {
        id: 3,
        image: Work5,
        title: "Random Dice Roller App made in Android Studio using Kotlin",
        url: "https://github.com/babi2707/DiceRoller",
        category: "Android Studio",
    },
    {
        id: 4,
        image: Work7,
        title: "ToDo List App made in Android Studio using Kotlin",
        url: "https://github.com/babi2707/ToDoListAndroidStudio",
        category: "Android Studio",
    },
    {
        id: 5,
        image: Work2,
        title: "Monopolly Game Bank Project using HTML and Firebase",
        url: "https://babi2707.github.io/BancoImobiliario/",
        category: "HTML",
    },
    {
        id: 6,
        image: Work3,
        title: "ToDo List Project using HTML and Firebase",
        url: "https://babi2707.github.io/toDoList/",
        category: "HTML",
    },
    {
        id: 7,
        image: Work8,
        title: "Github API Website Project using HTML, CSS and JavaScript",
        url: "https://babi2707.github.io/trabalho02/",
        category: "HTML",
    },
    {
        id: 8,
        image: Work4,
        title: "Pap Smear (Papanicolau) Recognition Project using Python and Artificial Intelligence",
        url: "https://github.com/babi2707/Trabalho-PAI---Reconhecimento-Papanicolau",
        category: "AI",
    }
]

export default Menu